// 首次进入展示
const b2bOrderList: any = [
  {
    imgSrc: require('@/assets/image/guide/order/step1-b.png'),
    returnBtn: [
      {
        height: '2%',
        width: '6%',
        top: '21%',
        left: '24%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '20%',
        left: '41%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/step2-b.png'),
    stepBtn: [
      {
        width: '4.5%',
        height: '3.5%',
        top: '29%',
        left: '60%'
      }
    ],
    returnBtn: [
      {
        height: '2%',
        width: '6%',
        top: '30%',
        left: '40%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/step3-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '38.7%',
        left: '54%'
      }
    ]
  }
]
const d2cOrderList: any = [
  {
    imgSrc: require('@/assets/image/guide/order/step1-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '22%',
        left: '84%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/step2-c.png'),
    stepBtn: [
      {
        width: '4.5%',
        height: '3.5%',
        top: '31%',
        left: '86%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/step3-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '39.7%',
        left: '53%'
      }
    ]
  }
]
// 下单后展示
const b2bOrder: any = [
  {
    imgSrc: require('@/assets/image/guide/order/order-step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '13%',
        left: '44%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step2-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '46%',
        left: '72%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step3-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '54%',
        left: '84%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step4-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '52.5%',
        left: '70%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step5-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '50%',
        left: '74%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step6-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '49%',
        left: '72%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step7-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '21.5%',
        left: '47%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step8-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '46%',
        left: '49%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step9-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '4.5%',
        top: '31%',
        left: '84%'
      }
    ]
  }
]
const d2cOrder: any = [

  {
    imgSrc: require('@/assets/image/guide/order/order-step1-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18%',
        left: '72%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step2-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '20%',
        left: '75%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step3-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '30%',
        left: '84%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step4-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '51%',
        left: '84%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step5-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '57%',
        left: '80%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step6-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '51%',
        left: '83%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step7-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '66%',
        left: '85%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step8-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '74%',
        left: '84.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step9-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '20%',
        left: '85%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/order/order-step10-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '48%',
        left: '85%'
      }
    ]
  }
]
const createAssociated: any = [

  {
    imgSrc: require('@/assets/image/guide/createAssociated/step1.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        left: '70.5%',
        top: '31.5%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        left: '51%',
        top: '31.7%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/createAssociated/step2.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '68%',
        top: '30.7%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        left: '53%',
        top: '30.7%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/createAssociated/step3.png'),
    returnBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '73.5%',
        top: '20.7%'
      }
    ]
  }
]
const b2bStockList: any = [
  {
    imgSrc: require('@/assets/image/guide/stock/step1-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '21.5%',
        left: '86.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '21.7%',
        left: '62.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step2-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '27.5%',
        left: '44.5%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        top: '27.7%',
        left: '22.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step3-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '20.5%',
        left: '63.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '20.7%',
        left: '49.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step4-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '27.5%',
        left: '76.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '26.7%',
        left: '50.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step5-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '27%',
        left: '73.5%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        top: '27%',
        left: '52.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step6-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '32.5%',
        left: '85%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        top: '32%',
        left: '69.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step7-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '10.5%',
        left: '80%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        top: '10.7%',
        left: '67.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step8-b.png'),
    stepBtn: [
      {
        height: '3.2%',
        width: '5%',
        top: '68.5%',
        left: '72.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '67.7%',
        left: '56.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step9-b.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '13%',
        left: '82%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '12.7%',
        left: '64.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step10-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '17.7%',
        left: '25.5%'
      }
    ]
  }
]
const d2cStockList: any = [
  {
    imgSrc: require('@/assets/image/guide/stock/step1-c.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '17.5%',
        left: '73.5%'
      }
    ],
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '58%',
        top: '17%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step2-c.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '31%',
        left: '35%'
      }
    ],
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '19%',
        top: '31%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step3-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '20%',
        top: '23%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        top: '23.5%',
        left: '38.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/stock/step4-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '42.5%',
        left: '78%'
      }
    ]
  }
]
const b2bOemList: any = [
  {
    imgSrc: require('@/assets/image/guide/oem/step1.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '64%',
        top: '21%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        left: '85%',
        top: '21%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step2.png'),
    stepBtn: [
      {
        width: '4%',
        height: '4%',
        left: '68%',
        top: '26.5%'
      }
    ],
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '50%',
        top: '26%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step3.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '43%',
        top: '31.5%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '57%',
        top: '31.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step4.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '79%',
        top: '14.5%'
      }
    ],
    returnBtn: [
      {
        width: '5%',
        height: '3.5%',
        left: '65%',
        top: '14.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step5.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '28.5%',
        left: '62%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        top: '28%',
        left: '77.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step6.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '17.5%',
        left: '64%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '17.5%',
        left: '78%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step7.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '42.5%',
        left: '60%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '42.5%',
        left: '47%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step8.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '45%',
        left: '78%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '45.5%',
        left: '60%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step9.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '45%',
        left: '69%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '45%',
        left: '80%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step10.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '58.5%',
        left: '52%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '58.5%',
        left: '63%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step11.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '61%',
        top: '18.5%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18.5%',
        left: '77%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step12.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '28.5%',
        left: '77%'
      }
    ]
  }
]
const d2cOemList: any = [
  {
    imgSrc: require('@/assets/image/guide/oem/step1-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '64%',
        top: '21%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.2%',
        left: '85%',
        top: '21%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step2-c.png'),
    stepBtn: [
      {
        width: '4%',
        height: '4%',
        top: '27.5%',
        left: '68%'
      }
    ],
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '50%',
        top: '28%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step3-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '43%',
        top: '36.5%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '57%',
        top: '36.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step4-c.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        left: '76%',
        top: '19.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '19.5%',
        left: '62%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step5-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '20.5%',
        left: '62%'
      }
    ],
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        top: '20.5%',
        left: '77%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step6-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '20%',
        left: '68%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '20%',
        left: '82%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step7-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '35.5%',
        left: '62%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '35.5%',
        left: '49%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step8-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '26.5%',
        left: '78%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '26%',
        left: '60%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step9-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '54%',
        left: '80%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '54%',
        left: '69%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step10-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '30%',
        left: '52%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '30%',
        left: '63%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step11-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        left: '61%',
        top: '38.5%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '38.5%',
        left: '77%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/oem/step12-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '43%',
        left: '83.5%'
      }
    ]
  }
]
const b2bShopcart: any = [
  {
    imgSrc: require('@/assets/image/guide/shopcart/step1-b.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '22.5%',
        left: '69%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '22.5%',
        left: '90%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step2-b.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '61.5%',
        left: '58%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '61.5%',
        left: '80%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step3-b.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '30%',
        left: '48%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '29.5%',
        left: '66%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step4-b.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '59.5%',
        left: '64%'
      }
    ]
  }
]
const d2cShopcart: any = [
  {
    imgSrc: require('@/assets/image/guide/shopcart/step1-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '22.5%',
        left: '69%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '22.5%',
        left: '90%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step2-c.png'),
    stepBtn: [
      {
        width: '4%',
        height: '3.5%',
        top: '47%',
        left: '35.5%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '47%',
        left: '24.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step3-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '67.5%',
        left: '56%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '67%',
        left: '77.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step4-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '32.5%',
        left: '45%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '32.5%',
        left: '63%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shopcart/step5-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '59%',
        left: '64%'
      }
    ]
  }
]
const cssociatedProduct: any = [
  {
    imgSrc: require('@/assets/image/guide/cssociatedProduct/step1.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '24.5%',
        left: '47%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '24.5%',
        left: '60%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/cssociatedProduct/step2.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '18%',
        left: '4%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18%',
        left: '26%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/cssociatedProduct/step3.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '15.5%',
        left: '71.5%'
      }
    ]
  }
]
const b2bUsercenter: any = [
  {
    imgSrc: require('@/assets/image/guide/usercenter/step1-b.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '43.5%',
        left: '17%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '43.5%',
        left: '39%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/usercenter/step2-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '13.5%',
        left: '46%'
      }
    ]
  }
]
const d2cUsercenter: any = [
  {
    imgSrc: require('@/assets/image/guide/usercenter/step1-c.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '43.5%',
        left: '17%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '43.5%',
        left: '39%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/usercenter/step2-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '15.5%',
        left: '45%'
      }
    ]
  }
]
const syncOrder: any = [

  {
    imgSrc: require('@/assets/image/guide/syncOrder/step1.png'),
    // returnBtn: [
    //   {
    //     width: '6%',
    //     height: '3.5%',
    //     top: '53.5%',
    //     left: '57%'
    //   }
    // ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '12.5%',
        left: '42%'
      }
    ]
  },

  {
    imgSrc: require('@/assets/image/guide/syncOrder/step2.png'),
    // returnBtn: [
    //   {
    //     width: '6%',
    //     height: '3.5%',
    //     top: '53.5%',
    //     left: '57%'
    //   }
    // ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '19.5%',
        left: '48%'
      }
    ]
  },

  {
    imgSrc: require('@/assets/image/guide/syncOrder/step3.png'),
    // returnBtn: [
    //   {
    //     width: '6%',
    //     height: '3.5%',
    //     top: '53.5%',
    //     left: '57%'
    //   }
    // ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '21.5%',
        left: '82%'
      }
    ]
  },

  {
    imgSrc: require('@/assets/image/guide/syncOrder/step4.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '24%',
        left: '48%'
      }
    ]
    // stepBtn: [
    //   {
    //     height: '3.5%',
    //     width: '4%',
    //     top: '53.5%',
    //     left: '78%'
    //   }
    // ]
  }
]
const createShipping: any = [
  {
    imgSrc: require('@/assets/image/guide/createShipping/step1.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '64.5%',
        left: '34%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/createShipping/step2.png'),
    returnBtn: [
      {
        width: '6%',
        height: '3.5%',
        top: '38%',
        left: '65%'
      }
    ]
  }
]
const combinedGoods: any = [
  {
    imgSrc: require('@/assets/image/guide/combinedGoods/step1.png'),
    returnBtn: [
      {
        height: '2.5%',
        width: '5%',
        top: '18.5%',
        left: '58%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '17.5%',
        left: '69%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/combinedGoods/step2.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '29.5%',
        left: '46%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '28.5%',
        left: '57%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/combinedGoods/step3.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '31%',
        left: '75.5%'
      }
    ]
  }
]
const shippingList: any = [
  {
    imgSrc: require('@/assets/image/guide/shippingList/step1.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '20.5%',
        left: '58%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '21%',
        left: '68.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shippingList/step2.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '43.5%',
        left: '66%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '43.5%',
        left: '77%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/shippingList/step3.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '23%',
        left: '84%'
      }
    ]
  }
]
const replenishmentList: any = [
  {
    imgSrc: require('@/assets/image/guide/replenishmentList/step1.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '20.5%',
        left: '72%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '20.5%',
        left: '41%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/replenishmentList/step2.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '22.5%',
        left: '41%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '22.5%',
        left: '26%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/replenishmentList/step3.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '27.5%',
        left: '47%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '27.5%',
        left: '26%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/replenishmentList/step4.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '37.5%',
        left: '67%'
      }
    ]
  }
]
const b2bAbnormalOrder: any = [
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '25.5%',
        left: '37%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '25.5%',
        left: '18%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step2-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '47.5%',
        left: '83%'
      }
    ]
  }

]
const d2cAbnormalOrder: any = [
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step1-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '45.5%',
        left: '57%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step2-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '50.5%',
        left: '75%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step3-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '41%',
        left: '86%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step4-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '68.5%',
        left: '89%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/abnormalOrder/step5-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '58.5%',
        left: '86%'
      }
    ]
  }

]
const orderDetail: any = [
  {
    imgSrc: require('@/assets/image/guide/orderDetail/step1.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '61.5%',
        left: '27%'
      }
    ]
  }
]
const b2bMaterialsList: any = [
  {
    imgSrc: require('@/assets/image/guide/materials/step1-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '25.5%',
        left: '56.5%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '25.5%',
        left: '67.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/materials/step2-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '5%',
        top: '18.5%',
        left: '72%'
      }
    ],
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18.5%',
        left: '83%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/materials/step3-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '18.5%',
        left: '83%'
      }
    ]
  }
]
const b2bAfterSale: any = [
  {
    imgSrc: require('@/assets/image/guide/afterSale/step1.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '39.5%',
        left: '80.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/afterSale/step2.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '62.5%',
        left: '75.5%'
      }
    ]
  }
]
const d2cCustomerFund: any = [
  {
    imgSrc: require('@/assets/image/guide/customerFund/step1.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '25%',
        left: '44%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '25%',
        left: '30.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/customerFund/step2.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '15.5%',
        left: '61%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '15.5%',
        left: '47.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/customerFund/step3.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '16%',
        left: '67.5%'
      }
    ]
  }
]
const b2bCustomerFund: any = [
  {
    imgSrc: require('@/assets/image/guide/customerFund/step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '26%',
        left: '45%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '26%',
        left: '29.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/customerFund/step2-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '17.5%',
        left: '58%'
      }
    ],
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '17.5%',
        left: '43.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/customerFund/step3-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '13.5%',
        left: '72%'
      }
    ]
  }
]
const d2cStoreFund: any = [
  {
    imgSrc: require('@/assets/image/guide/storeFund/step1.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18%',
        left: '69.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/storeFund/step2.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '27.5%',
        left: '80.5%'
      }
    ]
  }
]
const b2bStoreFund: any = [
  {
    imgSrc: require('@/assets/image/guide/storeFund/step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '18%',
        left: '69.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/storeFund/step2-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '27.5%',
        left: '80.5%'
      }
    ]
  }
]
const b2bAuthorizedStore: any = [
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '36%',
        left: '29.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step2-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '39%',
        left: '64.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step3-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '15%',
        left: '78.5%'
      }
    ]
  }
]
const d2cAuthorizedStore: any = [
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step1-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '27%',
        left: '32.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step2-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '33%',
        left: '65.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/authorizedStore/step3-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '11%',
        left: '77.5%'
      }
    ]
  }
]
const b2bSetup: any = [
  {
    imgSrc: require('@/assets/image/guide/setup/step1-b.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '47%',
        left: '81.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/setup/step2-b.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '42%',
        left: '79.5%'
      }
    ]
  }
]
const d2cSetup: any = [
  {
    imgSrc: require('@/assets/image/guide/setup/step1-c.png'),
    stepBtn: [
      {
        height: '3.5%',
        width: '4%',
        top: '47%',
        left: '81.5%'
      }
    ]
  },
  {
    imgSrc: require('@/assets/image/guide/setup/step2-c.png'),
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '39%',
        left: '78.5%'
      }
    ]
  }
]

// 成本估算新手引导
const estimatePrice = [
  {
    returnBtn: [
      {
        height: '3.5%',
        width: '6%',
        top: '56%',
        left: '19%'
      }
    ]
  }
]

export default {
  'estimate-price': estimatePrice,
  'b2b-order-list': b2bOrderList,
  'd2c-order-list': d2cOrderList,
  // 下单后展示
  'b2b-order': b2bOrder,
  'd2c-order': d2cOrder,
  // 创建关联商品
  'create-cssociated': createAssociated,
  // 在库管理
  'b2b-stock-list': b2bStockList,
  'd2c-stock-list': d2cStockList,
  // oem寻源
  'b2b-oem-list': b2bOemList,
  'd2c-oem-list': d2cOemList,
  // 购物车
  'b2b-shopcart': b2bShopcart,
  'd2c-shopcart': d2cShopcart,
  // 关联商品
  'cssociated-product': cssociatedProduct,
  // 工作台
  'b2b-usercenter': b2bUsercenter,
  // 工作台
  'd2c-usercenter': d2cUsercenter,
  // 同步订单
  'sync-order': syncOrder,
  // 创建国际发货
  'create-shipping': createShipping,
  // 组合商品
  'combined-goods': combinedGoods,
  // 国际发货列表
  'shipping-list': shippingList,
  // 补货计划
  'replenishment-list': replenishmentList,
  // 异常订单
  'b2b-abnormal-order': b2bAbnormalOrder,
  'd2c-abnormal-order': d2cAbnormalOrder,
  // 订单详情
  'order-detail': orderDetail,
  // 辅料
  'b2b-materials-list': b2bMaterialsList,
  // 国际发货售后
  'b2b-after-sale': b2bAfterSale,
  // 资金管理主账户2c
  'd2c-customer-fund': d2cCustomerFund,
  'b2b-customer-fund': b2bCustomerFund,
  // 资金管理子账户2c
  'd2c-store-fund': d2cStoreFund,
  'b2b-store-fund': b2bStoreFund,
  // 店铺配置
  'b2b-authorized-store': b2bAuthorizedStore,
  'd2c-authorized-store': d2cAuthorizedStore,
  // 设置
  'b2b-steup': b2bSetup,
  'd2c-steup': d2cSetup
}
